import {useState} from 'react';
import {ReactComponent as ArrowDownIcon} from '../../assets/common/arrow-down.svg';
import {ReactComponent as ArrowUpIcon} from '../../assets/common/arrow-up.svg';
import styles from './styles/axisdropdown.module.css';

export default function AxisDropdown({ axisList, axis, setAxis, settings }) {
    const [openDropdown, setOpenDropdown] = useState(false);

    const toggleDropdown = () => {
        setOpenDropdown(!openDropdown);
    };

    const clickAxis = (axis) => {
        setAxis(axis.displayKey);
        setOpenDropdown(false);
    };

    const selectedYAxis = settings ? settings.filter(setting => setting.variable && setting.chartType) : [];

    const buttonText = settings && selectedYAxis.length === 1
        ? selectedYAxis[0].variable
        : settings && selectedYAxis.length > 1
            ? `${selectedYAxis[0].variable} 외 ${selectedYAxis.length - 1}`
            : axis || '축 선택';

    return (
        <div className={styles.wrapper}>
            <button className={styles.btnDropdown} onClick={toggleDropdown}>
                <p>{buttonText}</p>
                {openDropdown ? <ArrowUpIcon/> : <ArrowDownIcon/>}
            </button>
            {openDropdown &&
                <ul>
                    {axisList.map((axis, index) => (
                        <li key={index}
                            onClick={() => clickAxis(axis)}
                        >
                            {axis.displayKey}
                        </li>
                    ))}
                </ul>
            }
        </div>
    );
}
